<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M12 3L2.5 19H21.5L12 3Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path d="M12 10V13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
  <circle cx="12" cy="16.5" r="0.75" fill="currentColor" />
</svg>
